import { render, staticRenderFns } from "./ViewAbout.vue?vue&type=template&id=bc8ce98e&"
import script from "./ViewAbout.vue?vue&type=script&lang=js&"
export * from "./ViewAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports